module.exports = __webpack_public_path__ + "fonts/Yekan-Bakh-Heavy.e7bee12d.ttf";